import generateId from '@com/utils/generate-id'
import Cookies from 'js-cookie'

const DEVICE_ID = '__device_id'
const COOKIE_EXPIRES = 365

export function getDeviceId(): string {
  // 优先从cookie中获取
  // 检查浏览器是否支持 cookie
  if (navigator.cookieEnabled) {
    let id = Cookies.get(DEVICE_ID)
    if (!id) {
      // 如果不存在标识符，则生成一个新的标识符
      id = generateId()
    }

    // 将标识符存储到浏览器的 cookie 中
    // 达到永久性存在的目的
    Cookies.set(DEVICE_ID, id, { expires: COOKIE_EXPIRES })

    return id
  }

  let deviceId = localStorage.getItem('deviceId')
  if (!deviceId) {
    deviceId = generateId()
    localStorage.setItem('deviceId', deviceId)
  }

  return deviceId
}
